export const weaponEnchantments = [
        {
        class: "rangement",
        rarity: "rare",
        name: "Veering",
        shortDesc: "Attacks with a veering weapon ignore a target’s bonus to AC from partial cover and reduce the target’s bonus to AC from cover and soft cover by 2. A veering weapon bestows no benefit against targets with total cover.",
        },
        {
            class: "all",
            rarity: "rare",
            name: "Penetration Focus",
            shortDesc: "While wielding this weapon you gain a bonus on checks made to overcome spell resistance equal to 2 + the weapons highest enchantment bonus.",
        },
        {
            class: "weapon",
            rarity: "legendary",
            name: "Versatile Design",
            shortDesc: "This weapon can be used to count as a different fighter weapon group. Ranged weapon groups cannot count as melee weapon groups and vice versa. To change its weapon group you must spend a swift action modifying the weapon, from then on, until changed again, it counts only as this new weapon group. You can also revert it to its normal weapon groups as a swift action.",
        },
        {
            class: "melee",
            rarity: "rare",
            name: "Binding",
            shortDesc: "You can use this weapon to perform grapple checks, doing so transforms it into a chain that wraps around the creature. This makes the weapon unusable until you end the grapple, which transforms the weapon back to its normal form. On a successful hit with this weapon you can attempt to grapple with the weapon as a free action which does not provoke attacks of opportunity. If this grapple attempt already did not provoke AoO's, then you gain a +2 bonus to it.",
        },
        {
            class: "all",
            rarity: "epic",
            name: "Gorefrenzy",
            shortDesc: "This weapon does +1 point of damage for each stack or source of bleeding the creature is currently suffering from. When you confirm a critical hit with this weapon you can choose for it to also deals 1d6 points of damage per stack or source of bleed, doing this removes all sources and stacks of bleed effecting the creature.",
        },
        {
            class: "melee",
            rarity: "rare",
            name: "Blanch Storing",
            shortDesc: "The weapon contains a container for blanches on the hilt, allowing it to release the perfect amount of the blanche with every attack. Blanches applied to this weapon last twice as many attacks.",
        },
        {
            class: "melee",
            rarity: "rare",
            name: "Dragon Catcher",
            shortDesc: "This weapon can be used to make a special trip maneuver against creatures using wings to fly. If the maneuver succeeds the target's wings are fouled and it is knocked off balance, falling to the ground and gaining the entangled condition. a Creature tripped this way can attempt a fly check DC 15+ weapon enchanement as a move action to remove the entangled condition.",
        },
        {
            class: "melee",
            rarity: "rare",
            name: "Duelist's Grip",
            shortDesc: "When you score a critical hit with this weapon you can make an additional surprise strike with the hilt of the weapon as a free action. This additional attack gains none of the enhancements of your weapon and counts as an entirely different weapon that is a light bludgeoning hammer, deals 1d6 damage and has a critical threat range of 20x2. You cannot use this ability against the same creature twice.",
        },        
        {
            class: "melee",
            rarity: "legendary",
            name: "Devouring",
            shortDesc: "This weapon has a large mouth on it that animates and chews on creatures when you score a successful critical hit. In addition to the damage of the critical hit it also deals 2 points of constitution damage, and the creature must make a fortitude save DC 13+enhancement bonus or it becomes stunned for 1 round. Creatures immune to critical hits are immune to both of these effects.",
        },
        {
            class: "melee",
            rarity: "epic",
            name: "Farreach",
            shortDesc: "As a standard action you can make a single melee attack against a creature within 60 feet as though it were within your melee reach. Cover and concealment apply as if making a ranged attack. You cannot use attack action or standard action attacks as part of this, except for vital strike feats.",
        },
        {
            class: "weapon",
            rarity: "rare",
            name: "Communion's Relief",
            shortDesc: "When you flank a creature with an ally who's alignment is within 1 step of yours, your attack bonus from flanking increases by +2. Additionally, this weapon ignores cover provided by allies who share at least 1 alignment component.",
        },
        {
            class: "weapon",
            rarity: "rare",
            name: "Last Whisper",
            shortDesc: "This weapon has its critical damage multiplier for delivering coup-de-grace attacks increased by +1. When you slay a creature with a coup-de-grace it you can spend a free action to move up to your movement speed, this provokes as normal.",
        },
        {
            class: "ranged",
            rarity: "epic",
            name: "Conserving",
            shortDesc: "When you fire special ammunition from this weapon, if the attack misses and causes it to have no effect, the ammunition has a 50% chance to instantly return to your bag. This is a teleportation effect.",
        },
        {
            class: "melee",
            rarity: "rare",
            name: "Toppling",
            shortDesc: "You can spend level spell points when making an attack with this weapon, if the attack succeeds you can cause the creature to make a fortitude save DC 17+enhancement bonus or fall prone.",
        },
        {
            class: "melee",
            rarity: "epic",
            name: "Heartripper",
            shortDesc: `When you deliver a coup-de-grace with this weapon against a living creature, it tears out their heart. The heart can later be consumed as a movement action to bestow one of the effects: \nHeal hitpoints equal to two times the HD of the creature\nRestore spell points equal to 1/2 the HD of the creature\nBe affected by the spell lesser restoration.
            \nA heart created by this effect only lasts for the rest of the floor, and you can never have more hearts than half this weapons enhancement modifier (minimum 1).`,
        },
        {
            class: "melee",
            rarity: "common",
            name: "Felling",
            shortDesc: "You can trip opponents one size larger than you usually can when using this weapon (by default that is two sizes larger than you), and trip attempts with this weapon gain a +4 bonus. When you successfully trip a creature with this weapon you deal damage equal to the weapons enhancement bonus.",
        },
        // {
        //     class: "all",
        //     rarity: "legendary",
        //     name: "End's Harbinger",
        //     shortDesc: "",
        // },
        {
            class: "melee",
            rarity: "epic",
            name: "Seismic Assault",
            shortDesc: "When you confirm a critical hit with this weapon a concussive blast emits from the weapon in a 10-foot-radius spread, causing a tremor that knocks any standing creature prone if its CMD is equal to or lower than the result of the confirmation roll. This damaged area is also considered difficult terrain for rounds equal to the highest enchantment bonus.",
        },
        {
            class: "melee",
            rarity: "legendary",
            name: "Shadow Shifting",
            shortDesc: "Once per day when you miss an attack with this weapon, you can as an immediate action activate the dagger to teleport as per the spell dimensional door to any unoccupied square within 30 feet and can attempt a Stealth check to hide as if you were not being observed. You cannot take any other creatures with you when you activates the enchantment. Activating the enchantment does not provoke attacks of opportunity.",
        },
        {
            class: "weapon",
            rarity: "epic",
            name: "Sword-Saint's Blade",
            shortDesc: "When using the flurry of blows ability this weapon can be used to make attacks during it, if it already could have been, then it also gains the dice step increases, If it already gained the dice steps increase, it gains an additional dice step increase during flurry of blows.",
        },
        {
            class: "all",
            rarity: "rare",
            name: "Blood Drinker",
            shortDesc: "When a creature except you takes bleed damage within 15 feet, you gain temporary hit points equal to half the bleed damage they took. These stack, and last 1 minute. Critical hits with this weapon deal 2 points of bleed damage.",
        },        
        {
            class: "weapon",
            rarity: "rare",
            name: "Ghost Touch",
            shortDesc: "A ghost touch weapon deals damage normally against incorporeal creatures, regardless of its bonus. An incorporeal creature’s 50% reduction in damage from corporeal sources does not apply to attacks made against it with ghost touch weapons. The weapon can be picked up and moved by an incorporeal creature at any time. A manifesting ghost can wield the weapon against corporeal foes. Essentially, a ghost touch weapon counts as both corporeal or incorporeal.",
        },
        {
            class: "weapon",
            rarity: "rare",
            name: "Master's Blade",
            shortDesc: "Attacks made with this weapon made during a martial maneuver deal an extra 2d6 damage.",
        },
        {
            class: "ranged",
            rarity: "rare",
            name: "Extendo Mag",
            shortDesc: "This enchantment can only be placed on firearms and crossbows. The weapon has double the capacity it can be fired before needing to be reloaded.",
        },
        // {
        // class: "all",
        // rarity: "epic",
        // name: "Biting Intellect",
        // shortDesc: "This weapon deals additional damage equal to the difference between your intellegence score, and the intellegence score of the target. This affect ONLY works with intellegence.",
        // },
        {
            class: "all",
            rarity: "rare",
            name: "Quickdraw",
            shortDesc: "A weapon with this enchantment can be either sheathed or drawn once per round as a swift action, if you have quickdraw it is instead a free action, but you can still only do this once per round. If you gain this enchantment a second time it becomes a free action you can do once per round, if it is already a free action increase the amount of times a round you can do it by 1.",
        },
        {
        class: 'all',
        name: "Unbreakable",
        rarity: "common",
        shortDesc: "Increase your weapons hardness by 5",
        },
        {
        class: 'all',
        name: "Indestructable",
        rarity: "common",
        shortDesc: "your weapon gains 10 hit points",
        },
        {
        class: "all",
        rarity: "common",
        name: "Empowering",
        shortDesc: "While wielding this weapon in your hand, your damaging spells deal additional damage equal to the enchantment bonus on this weapon (minimum 1). This only applies to a single damage roll that is rolled during the duration of the spell.",
        },
        {
        class: "melee",
        rarity: "common",
        name: "Finessed",
        shortDesc: "This weapon can use dexterity to attack instead of strength, and counts as being a weapon that can be used with weapon finesse. If you already have dexterity to attack you can instead use dexterity to damage.",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Focusing",
        shortDesc: "While wielding this weapon in your hand you can reduce the cost of spells by 1 spell point, spells still cost a minimum of 1 spell point.",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Draining",
        shortDesc: "If you strike a creature with this weapon you can gain 1 spell point. If you cast a spell that successfully deals damage while wielding this weapon you can also regain 1 spell point, this can only trigger once per spell.",
        },
        {
        class: "melee",
        rarity: "common",
        name: "Sharding",
        shortDesc: "The wielder of a sharding weapon can make a special ranged attack with the weapon in place of any melee attack. To do this, the wielder goes through the motion of throwing the weapon without releasing it. The weapon splits off a duplicate of itself that flies as if thrown by the wielder at the intended target. The duplicate gains a range increment of 10 feet for this purpose, but uses the same proficiency and otherwise functions the same as the original weapon. The duplicate vanishes after hitting or missing its target.",
        },
        {
        class: "rangement",
        rarity: "common",
        name: "Plummeting",
        shortDesc: "A flying creature hit with a plummeting weapon must immediately attempt a DC 20 Fly check with a penalty equal to twice the weapon’s enhancement bonus; if it fails, it loses 10 feet of altitude. On a confirmed critical hit, the creature loses 10 feet of altitude if it succeeds at its Fly check, and it falls 1d4×10 feet on a failed check. If a flying creature’s loss of altitude results in it striking the ground or another solid surface, it takes falling damage as appropriate and is no longer flying.",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Limning",
        shortDesc: "On a successful strike against a creature affected by a means of magical concealment, the weapon outlines the creature in faerie fire (as the spell) for 1 round. Magical means of concealment include blur, displacement, invisibility, and similar effects, whether from a spell, spell-like ability, or supernatural means, but not those provided by extraordinary abilities, no longer grant the creature concealment. This does not help against creatures who merely hiding or concealed by non-magical means, or those hidden by environmental conditions (even magical) such as darkness or fog.",
        },
        {
            class: "melee",
            rarity: "rare",
            name: "Anchoring",
            shortDesc: "When you hit a creature with this weapon you can spend a swift action to fix it in a point in space and attach it to the creature struck. This functions as an immovable rod, and causes the target to be unable to move from its current space. The target suffers no other penalty such as entanglement or paralysis, and must either destroy the weapon or make a strength check DC 20 + weapon enhancement bonus as a full-round action to move up to its movement speed, which brings the weapon with them. The weapon remains motionless and unsuable while it is anchoring a creature, and has no effect on amorphous creatures, including elementals and oozes, or gas or liquid creatures, nor can it anchor incorporeal creatures unless it also has the ghost touch ability. Teleportation frees the creature from this affect.",
        },
        {
            class: "all",
            rarity: "rare",
            name: "Phase Locking",
            shortDesc: "A phase locking weapon interferes with dimensional travel. A creature damaged by a phase locking weapon is affected as though by the dimensional anchor spell for 1 round, this blocks most forms of teleportation, or plane shifting, such as ethereal jaunt",
        },
        {
            class: "weapon", 
            rarity: "common",
            name: "Igniting",
            shortDesc: "When you score a critical hit with this weapon it ignites the creature, causing it to take damage as if it was on fire. This deals 1d6 points of fire damage at the start of each of its turns, and when it catches on fire. Each turn at the start of its turn it can put out the fire and avoiding taking any damage by making a reflex save DC 15 + weapons enchancement bonus, this otherwise functions as the normal catching on fire rules.",
        },
        {
            class: "armament", 
            rarity: "common",
            name: "Spell Burning",
            shortDesc: "When you score a critical hit with a spell while wielding this weapon, it ignites the creature, causing it to take damage as if it was on fire, except that it deals whichever element the spell dealt (highest if multiple, choice if equal). This deals 1d6 points of damage at the start of each of its turns, and when the arcane burn starts. Each turn at the start of its turn it can put out the arcane burn and avoiding taking any damage by making a reflex save DC 15 + weapons enchancement bonus, this otherwise functions as the normal catching on fire rules. This damage gains double the bonus from spell power.",
        },
        {
        class: "melee",
        rarity: "common",
        name: "Invigorating",
        shortDesc: "After an attack with this weapon drops a living foe (kills it or drops it to negative hit points), the weapon infuses its wielder with vigor. If its wielder is fatigued, the weapon removes the fatigue. If exhausted, the wielder becomes fatigued instead. If neither exhausted nor fatigued, the wielder gains a +2 morale bonus on attack rolls and a +10 foot enhancement bonus to all modes of movement possessed until the end of the wielder’s next turn.",
        },
        {
        class: "ranged",
        rarity: "common",
        name: "Driving",
        shortDesc: "A driving weapon can be used to perform bull rush and trip combat maneuvers in its first range increment. A successful ranged bull rush does not require the wielder to move to push the target farther than 5 feet. A ranged trip that fails by 10 or more cannot result in the attacker being knocked prone.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Opportunistic",
        shortDesc: "You gain an additional attack of opportunity per round per 3 enhancement bonus on this weapon (minimum 1)",
        },
        {
        class: "all",
        rarity: "common",
        name: "Distracting",
        shortDesc: "Weapons with this special ability cause foes struck by them to have difficulty controlling their magic. Any time a creature that has been struck by a distracting weapon would have to succeed at a concentration check to complete a spell or use a special ability or item, the DC of that check increases by 5. This distraction lasts for 1 minute. Once a distracting weapon affects a creature in this way, that creature can’t be affected by a distracting effect for 24 hours, though it can be affected by a greater distracting effect.",
        },
        {
        class: "ragement",
        rarity: "common",
        name: "Designating lesser",
        shortDesc: "This special ability can only be placed on ranged weapons or ammunition. Each time a ranged weapon or ammunition with this ability hits a creature, its magic designates the target. Allies gain a +2 morale bonus on melee attack and melee damage rolls against the designated target for 1 round. Multiple successful shots fired at the same target do not increase the bonuses or their duration.",
        },
        {
        class: "melee",
        rarity: "common",
        name: "Deceptive",
        shortDesc: "When the weapon is in hand, the wielder gains a bonus on Bluff checks to feint equal to the enhancement bonus of the weapon. In addition, when the wielder successfully confirms a critical hit with a deceptive weapon against an opponent, she can attempt to feint against that opponent as a free immediate action.",
        },
        {
        class: "melee",
        rarity: "common",
        name: "Advancing",
        shortDesc: "Once per round, when the wielder damages a creature in melee with an advancing weapon, she can take a 5-foot step as a swift action after the attack but before the end of her turn. This movement does not count against her ability to move or take a 5-foot step earlier or later in the round, though using this ability imposes a —2 penalty on all attack rolls until the start of her next turn. This ability may not be used in conjunction with any other ability or effect that allows moving as part of an attack.",
        },
        {
        class: "all",
        rarity: "common",
        name: "Benevolent",
        shortDesc: "When the wielder of a benevolent weapon uses the aid another action to grant an ally a bonus on attack rolls, he increases the aid another bonus by the highest enhancement bonus of the weapon.",
        },
        {
        class: "all",
        rarity: "common",
        name: "Called",
        shortDesc: "A called weapon can be teleported to the wielder’s hand as a swift action that does not provoke attacks of opportunity, even if the weapon is in the possession of another creature. This ability has a maximum range of 100 feet, and effects that block teleportation prevent the return of a called weapon",
        },
        {
        class: "weapon",
        rarity: "common",
        name: "Cruel",
        shortDesc: "When the wielder strikes a creature that is frightened, shaken, or panicked with a cruel weapon, that creature becomes sickened for 1 round. When the wielder uses the weapon to knock unconscious or kill a creature, he gains 5 + enhancement modifier temporary hit points that last for 10 minutes.",
        },
        {
        class: "all",
        rarity: "common",
        name: "Defending",
        shortDesc: "A defending weapon allows the wielder to transfer some or all of the weapon’s enhancement bonus to his AC as a bonus that stacks with all others. As a free action, the wielder chooses how to allocate the weapon’s enhancement bonus at the start of his turn before using the weapon, and the bonus to AC lasts until his next turn. This ability can only be placed on melee weapons, and only works if the wielder makes at least 1 with the weapon on their turn.",
        },
        {
        class: "melee",
        rarity: "common",
        name: "Furious",
        shortDesc: "A furious weapon serves as a focus for its wielder’s anger. When the wielder is raging or under the effect of a rage spell, the weapon’s enhancement bonus is +2 better than normal. While raging gain the weapons enhancement bonus to swim, acrobatics, and climb checks.",
        },
        {
        class: "melee",
        rarity: "common",
        name: "Throwing",
        shortDesc: "A melee weapon crafted with this ability gains a range increment of 10 feet and can be thrown by a wielder proficient in its normal use.",
        },
        {
        class: "melee", 
        rarity: "common",
        name: "Vicious",
        shortDesc: "When a vicious weapon strikes an opponent, it creates a flash of disruptive energy that resonates between the opponent and the wielder. This energy deals an extra 2d6 points of damage to the opponent and 1d6 points of damage to the wielder.",
        damageMod:"2d6"
        },
        {
        class: "melee",
        rarity: "common",
        name: "Thundering",
        shortDesc: "A thundering weapon creates a cacophonous roar like thunder whenever it strikes a target with a successful critical hit. The sonic energy does not harm the wielder. A thundering weapon deals an extra 1d8 x the critical multiplier points of sonic damage on a successful critical hit. Subjects dealt critical hits by a thundering weapon must make a successful Fortitude save DC 14 + weapon enhancement bonus or be deafened permanently.",
        },
        {
            class: "melee",
            rarity: "unique",
            name: "Prowler's Claw",
            shortDesc: "Whenever you use an ability that teleports you any amount of distance or turns you invisible/stealths you, your next melee attack with this weapon during the same round deals an additional 3d6 damage. For every +3 enhancement bonus this weapon has, add 1d6 damage to this effect.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Furyborn",
        shortDesc: "This special ability can only be placed on melee weapons. A furyborn weapon draws power from the anger and frustration the wielder feels when battling foes that refuse to die. Each time the wielder damages an opponent with the weapon, its enhancement bonus increases by +1 when making attacks against that opponent (to a maximum total enhancement bonus of +5). This extra enhancement bonus goes away if the opponent dies, the wielder uses the weapon to attack a different creature, or 1 hour passes.",
        },
        {
        class: "all",
        rarity: "common",
        name: "+1",
        shortDesc: "+1 to attack and damage. This also grants 2 universal spell power.",
        spellPower:[{type:"universal", power:2}]
        },        
        {
        class: "weapon",
        rarity: "common",
        name: "Adapting",
        shortDesc: "This weapon adapts to the needs of the user, dealing blugeoning, piercing, or slashing damage. You decide what type of damage it should do as a free action before an attack.",
        },
        {
        class: "melee",
        rarity: "common",
        name: "Agile",
        shortDesc: "You can choose to use dexterity as your damage modifier with this weapon instead of its normal ability score modifier. If you already could use dexterity as the ability score modifier to damage for this weapon, increase the damage bonus you gain from dexterity by 50%.",
        },
        {
            class: "melee",
            rarity: "epic",
            name: "Mighty",
            shortDesc: "When this weapon is using strength to determine its damage modifier, you increase the bonus the ability scores provides to damage by 0.5x of the modifier. This is modified the same way the base ability score is when determining damage (off-hand 0.25x, two-handed: 0.75x).",
        },
        {
            class: "all",
            rarity: "legendary",
            name: "Tuned",
            shortDesc: "You increase the bonus the ability score (if any) provides to this weapons damage by 0.5x of the modifier. This is modified the same way the base ability score is when determining damage (off-hand 0.25x, two-handed: 0.75x).",
        },
        {
        class: "rangement",
        rarity: "common",
        name: "Distance",
        shortDesc: "Double the range increment of this weapon.",
        },
        {
        class: "rangement",
        rarity: "rare",
        name: "Seeking",
        shortDesc: "A seeking weapon veers toward its target, negating any miss chances that would otherwise apply, such as from concealment. The wielder still has to aim the weapon at the right square. Arrows mistakenly shot into an empty space, for example, do not veer and hit invisible enemies, even if they are nearby.",
        },
        {
            class: "armament",
            rarity: "rare",
            name: "Seeking",
            shortDesc: "A seeking weapon veers toward its target, negating any miss chances that would otherwise apply, such as from concealment. The wielder still has to aim the weapon at the right square. Arrows mistakenly shot into an empty space, for example, do not veer and hit invisible enemies, even if they are nearby.",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Vampiric ",
        shortDesc: "You heal 1 hitpoint every time you hit a creature and deal damage with this weapon. This isn't positive energy.",
        },
        // {
        // class: "all",
        // rarity: "epic",
        // name: "Transformative",
        // shortDesc: "A greater transformative weapon becomes any other weapon the wielder desires when a command word is spoken. The weapon cannot become ammunition, but can freely change between simple, martial, exotic, light, one-handed, two-handed, melee, and ranged. The weapon retains all of its enhancement bonuses and weapon special abilities. However, abilities prohibited by its current shape do not function. For example, a keen greater transformative weapon functions normally in the form of a piercing or slashing weapon, but cannot use the keen special ability when in the shape of a bludgeoning weapon. A double weapon that loses the double quality cannot use the abilities on one of its ends (wielder’s choice), whereas a non-double weapon that gains the double quality applies all its abilities to only one end. When unattended for 1 day, the weapon reverts to its true shape.",
        // },
        {
        class: "all",
        rarity: "epic",
        name: "Spell Stealing",
        shortDesc: "When the wielder rolls a critical threat against a target with this weapon, they can forgo confirming the critical hit and instead automatically learn which spells or magical effects are active upon the target. The wielder may then make a caster level check to steal her choice of one of those effects, using your level or bab plus your weapons enhancement bonus, against a DC of 11 + the caster level of the effect. If the check succeeds, the target immediately loses the benefits of that effect and the wielder gains the effect for 1 minute (or until the effect expires, whichever comes first). If the spellstealing weapon has a critical multiplier greater than x2, the wielder may attempt to steal one additional spell effect per additional multiple beyond x2 (two effects for x3, and so on).",
        },
        {
        class: "melee",
        rarity: "epic",
        name: "Quaking",
        shortDesc: "The wielder of a quaking weapon can strike the ground as a standard action to perform a trip combat maneuver that applies to all foes within a 5-foot-radius spread, a 10- foot cone, or a 20-foot line along the ground. The wielder can trip creatures of any size this way. This trip maneuver attempt provokes attacks of opportunity unless the wielder has some feat or ability that prevents it, and the wielder can never be knocked prone as a result of failing this special trip combat maneuver check.",
        },
        {
        class: "rangement",
        rarity: "epic",
        name: "Designating Greater",
        shortDesc: "Each time a ranged weapon or ammunition with this ability hits a creature, its magic designates the target. Allies gain a +4 morale bonus on melee attack rolls and a +6 morale bonus on melee damage rolls against the designated target for 1 round. Multiple successful shots fired at the same target do not increase the bonuses or their duration.",
        },        
        {
            class: "ranged",
            rarity: "epic",
            name: "Huntsman",
            shortDesc: "The first time you hit and damage a creature with this weapon, you can make a survival check DC 20 + the creatures hit dice, gaining a bonus equal to this weapons enhancement bonus. If you succeed all of your further attacks with this weapon deal an additional 1d6 damage, plus an additional 1d6 for each 10 you beat the DC of the survival check.",
        },
        {
        class: "ranged",
        rarity: "epic",
        name: "Nimble Shot",
        shortDesc: "A nimble shot weapon doesn't provoke attacks of opportunity when fired.",
        },
        {
            class: "armament",
            rarity: "epic",
            name: "Nimble Mage",
            shortDesc: "A nimble Mage weapon doesn't provoke attacks of opportunity when fired. Also grants a +4 bonus to concentration checks while combat casting.",
        },
        {
        class: "melee",
        rarity: "epic",
        name: "Freeing",
        shortDesc: "As a standard action, the wielder of a freeing weapon can free herself or an adjacent creature from spells and abilities that inhibit movement, such as paralysis, solid fog, slow, and web. The wielder attempts a combat maneuver check while holding the weapon (DC = 15 + either the spell’s caster level or the creature’s HD); success dispels the effect. Only a single attempt can be made against each spell or effect.",
        },
        {
        class: "melee",
        rarity: "epic",
        name: "Leveraging",
        shortDesc: "The wielder of a leveraging weapon gains a bonus equal to the weapon’s enhancement bonus to her Combat Maneuver Defense against bull rush, drag, reposition, and trip combat maneuvers. The leveraging weapon’s enhancement bonus is doubled when applied to combat maneuver checks to attempt bull rush, drag, reposition, and trip combat maneuvers.",
        },
        {
        class: "melee",
        rarity: "common",
        name: "Legbreaker",
        shortDesc: "A legbreaker weapon reduces the base land speed of a struck creature by 10 feet for 1d4 rounds. Multiple hits from a legbreaker weapon do not reduce a creature’s land speed further, but they do extend the duration of the penalty. This speed penalty can be removed with a successful DC 15 Heal check. On a critical hit, in addition dealing critical damage and impeding the victim’s speed, the wielder may perform a free trip combat maneuver against the struck creature",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Guardian",
        shortDesc: "A guardian weapon allows the wielder to transfer some or all of the weapon’s enhancement bonus to his saving throws as a bonus that stacks with all others. As a free action, the wielder chooses how to allocate the weapon’s enhancement bonus at the start of his turn before using the weapon. The bonus on saving throws lasts until his next turn. Only the weapon’s own enhancement bonus can be sacrificed, not any enhancement bonus provided by other effects such as a greater magic weapon spell. However, the total of such effects is still diminished by the amount allocated to improving saving throws. You must make an attack with this weapon on your turn for this ability to function.",
        },
        {
        class: "melee",
        rarity: "epic",
        name: "Gory",
        shortDesc: "This weapon deals 1d2 points of bleed damage when it deals damage, these stack, but are removed whenever the creature is healed by a magical source, or succeeds a heal check dc 15 to treat the bleeding as a standard action. Additionally, when the wielder confirms a critical hit with this weapon, he can attempt an Intimidate check to demoralize the target as an immediate action with a circumstance bonus equal to his character level plus the weapons enhancement bonus.",        
        },
        {
            class: "all",
            rarity: "unique",
            name: "Beholder's Bane",
            shortDesc: "This weapon has its caster level increased by 4 (plus this enchantment itself) for the purposes of being dispelled, additionally for rounds per day equal to your highest enchantment modifier this weapon functions inside of an antimagic field (minimum 1).",        
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Exhausting",
        shortDesc: "On a critical hit, the wielder can choose to forgo the additional damage dice to instead sap the struck creature’s strength and stamina, causing it to become exhausted. Opponents that are already exhausted don’t suffer any additional effects, and creatures immune to the effects of exhaustion or to critical hits are not affected.",
        },
        {
        class: "all",
        rarity: "epic",
        name: "Greater Distracting",
        shortDesc: "Any time a creature that has been struck by a greater distracting weapon would have to succeed at a concentration check to complete a spell or use a special ability or item, the DC of that check increases by 10. This distraction lasts for 1 minute. Once a greater distracting weapon affects a creature in this way, that creature can’t be affected by a distracting or greater distracting effect for 24 hours. This does not stack with the distracting enchantment.",
        },
        {
        class: "all",
        rarity: "epic",
        name: "Beaming",
        shortDesc: "For level spell points as a swift action, a beaming weapon creates a number of glowing orbs equal to the weapon’s enhancement bonus(miniumum 1). The orbs float around the wielder’s head like a halo and fire rays of light at the wielder’s foes. Once per round when the wielder makes an attack or full-attack with the beaming weapon, the wielder can expend one orb as a free action to fire a beam of as if the spell searing light at any target within range. The spell is cast at the wielders level.",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Holy",
        shortDesc: "The weapon deals 2d6 additional damage to all evil creatures and counts as good for bypassing DR. Also grants 10 spell power to good spells.",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Unholy",
        shortDesc: "The weapon deals 2d6 additional damage to all to all good creatures and counts as evil for bypassing DR. Also grants 10 spell power to evil spells.",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Axiomatic",
        shortDesc: "The weapon deals 2d6 additional damage to all chaotic creatures and counts as lawful for bypassing DR. Also grants 10 spell power to lawful spells.",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Anarchic",
        shortDesc: "The weapon deals 2d6 additional damage to all lawful creatures and counts as chaotic for bypassing DR. Also grants 10 spell power to chaotic spells.",
        },
        {
        class: "all",
        rarity: "epic",
        name: "+3",
        shortDesc: "+3 attack and damage. Also grants 6 universal spell power.",
        spellPower:[{type:"universal", power:6}]
        },        
        {
        class: "all",
        rarity: "rare",
        name: "+2",
        shortDesc: "+2 attack and damage. Also grants 4 universal spell power.",
        spellPower:[{type:"universal", power:4}]
        },            
        {
        class: "melee",
        rarity: "rare",
        name: "Wounding",
        shortDesc: "A wounding weapon deals 1 point of bleed damage when it hits a creature. Multiple hits from a wounding weapon increase the bleed damage. Bleeding creatures take the bleed damage at the start of their turns. Bleeding can be stopped by a successful DC 15 Heal check or through any magical healing. A critical hit does not multiply the bleed damage. Creatures immune to critical hits are immune to the bleed damage dealt by this weapon.",
        },
        {
        class: "all",
        rarity: "legendary",
        name: "Devastating",
        shortDesc: "A devastating weapon increases its critical damage multiplier by +1. Also grants +15% universal spell critical damage.",
        spellCriticalDamage:[{type:"universal", power:15}]
        },
        {
        class: "all",
        rarity: "legendary",
        name: "Deadly Hone",
        shortDesc: "Increase your critical threat range by 2, this is a flat bonus that is not modified by other abilities. It also grants 2% universal spell critical chance.",
        },
        {
        class: "all",
        rarity: "legendary",
        name: "Perfect Combo",
        shortDesc: "This weapon no longer threaten critical hits on any roll of the dice, however every sixth attack with this weapon threatens a critical hit if it hits, and can be confirmed as normal. Affects that only activate on natural 20's still activate, and must be confirmed, but do not automatically activate on the 6th hit. If you get perfect combo again, you crit every 5 attacks instead.",
        },
        {
        class: "ranged",
        rarity: "epic",
        name: "Precise Shooting",
        shortDesc: "You can add dexterity to damage on ranged attacks with this weapon. If your weapon already added an ability modifier to the damage this replaces that.",
        },
        {
        class: "ranged", 
        rarity: "legendary",
        name: "Second Chance",
        shortDesc: "Once per round, when a shot made with this weapon misses its target, as a free action the weapon’s wielder can cause that shot to swerve and try to hit the target again. The arrow fired gets a second attack at the same attack bonus as the first attack it made.",
        },
        {
        class: "rangement",
        rarity: "legendary",
        name: "Interfering",
        shortDesc: "The wielder can make attacks of opportunity with an interfering weapon as if he threatened all spaces within the weapon’s first range increment or 30 feet, whichever is closer. However, the wielder cannot make multiple ranged attacks of opportunity with an interfering weapon against a creature that moves out of multiple threatened spaces within range using a single move action, even if the wielder has Combat Reflexes or other effects that allow multiple attacks of opportunity.",
        },        
        {
        class: "ranged",
        rarity: "unique",
        name: "Heart-Piercing",
        shortDesc: "Upon a roll of natural 20 (followed by a successful roll to confirm the critical hit), the weapon pierces the opponent’s heart (if it has one). Some creatures, such as those immune to critical hits, like many aberrations and all oozes, have no hearts. Others, such as golems and undead creatures other than vampires, are not affected by the loss of their hearts. Most other creatures, however, die when their heart is pierced.",
        },
        {
        class: "melee",
        rarity: "legendary",
        name: "Dancing",
        shortDesc: "As a standard action, a dancing weapon can be loosed to attack on its own. It fights for 4 or weapon enhancement modifier rounds (whichever is prefered) using the base attack bonus of the one who loosed it plus its enhancement bonuses and then drops. While dancing, it cannot make attacks of opportunity, and the activating character it is not considered armed with the weapon. The weapon is considered wielded or attended by the activating character for all maneuvers and effects that target items. While dancing, the weapon shares the same space as the activating character and can attack adjacent foes (weapons with reach can attack opponents up to 10 feet away). The dancing weapon accompanies the activating character everywhere, whether she moves by physical or magical means. If the activating character has an unoccupied hand, she can grasp it while it is attacking on its own as a free action; when so retrieved, the weapon can’t dance (attack on its own) again for 2 rounds.",
        },
        {
        class: "melee",
        rarity: "unique",
        name: "Vorpal",
        shortDesc: "Upon a roll of natural 20 (followed by a successful roll to confirm the critical hit), the weapon severs the opponent’s head (if it has one) from its body. Some creatures, such as many aberrations and all oozes, have no heads. Others, such as golems and undead creatures other than vampires, are not affected by the loss of their heads. Most other creatures, however, die when their heads are cut off.",
        },
        {
        class: "all",
        rarity: "legendary",
        name: "Speed",
        shortDesc: "When making a full-attack action, the wielder of a speed weapon may make one extra attack with it. The attack uses the wielder’s full base attack bonus, plus any modifiers appropriate to the situation. (This benefit is cumulative with similar effects, such as a haste spell.)",
        },
        {
        class: "weapon",
        rarity: "epic",
        name: "Brilliant Energy",
        shortDesc: "A brilliant energy weapon has its significant portion transformed into light, although this does not modify the item’s weight. It always gives off light as a torch (20-foot radius). A brilliant energy weapon ignores nonliving matter. Armor and shield bonuses to AC (including any enhancement bonuses to that armor) do not count against it because the weapon passes through armor. (Dexterity, deflection, dodge, natural armor, and other such bonuses still apply.) A brilliant energy weapon cannot harm undead, constructs, or objects.",
        },
        {
        class: "all",
        rarity: "legendary",
        name: "+4",
        shortDesc: "+4 to attack and damage. This also grants 8 universal spell power.",
        spellPower:[{type:"universal", power:8}]
        },        
        {
        class: "all",
        rarity: "rare",
        name: "Truthful",
        shortDesc: "A truthful weapon unerringly pierces concealment provided by illusions, allowing the wielder to ignore the miss chance provided by illusions such as blur, displacement, and invisibility. Attacks with a truthful weapon against a creature affected by mirror image or a similar figment always attack the real target. This ability allows the wielder to ignore the miss chance, not to otherwise detect the target. When attacking an invisible creature, for instance, the wielder might still need to guess the target’s location.",
        },
        {
        class: "weapon",
        rarity: "common",
        name: "Training",
        shortDesc: "a training weapon grants one martial feat to the wielder as long as they wield the weapon.",
        },
        {
        class: "weapon",
        rarity: "rare",
        name: "Stalking",
        shortDesc: "The longer the wielder of a stalking weapon studies a target, the more effective her strike. As a swift action, a character wielding a stalking weapon can command it to study a creature within 60 feet. The wielder must have line of effect and line of sight to that target. When the wielder attacks the studied creature, on a successful hit the stalking weapon deals +1d6 points of bonus damage per consecutive round spent studying a target, up to a number of bonus dice equal to the stalking weapon’s enhancement bonus (minimum 1). This bonus damage is precision damage and only applies to the first successful hit against that creature. If the wielder commands the weapon to study a different creature, or ends her turn more than 60 feet from the studied creature, the weapon loses all bonus damage dice against the previously studied creature.",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Chargable",
        shortDesc: "If you are wielding this weapon in your hand when you cast a spell, this weapon becomes magically charged, gaining a bonus to its next attack roll equal to the level of the spell cast. This attack has to be within rounds equal to the spells level",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Arcane Destruction",
        shortDesc: "If you are wielding this weapon in your hand when you cast a spell, this weapon becomes arcanely charged, gaining a bonus to its next damage roll equal to twice the level of the spell cast. If the spell has an elemental damage type associated with it this bonus damage can be of that type, otherwise it is of the weapons damage type. This attack has to be within rounds equal to the spells level. This bonus stacks with itself.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Sneaky",
        shortDesc: "For sneak attack dice spell points as a free action, the wielder of a sneaky weapon can designate a single foe within his melee reach as his prey. The wielder adds his sneak attack damage to the next attack he makes against his prey, even if the wielder is not flanking and the target is not denied its Dexterity bonus to AC, as long as that attack is made before the end of the wielder’s next turn",
        },
        {
        class: "weapon",
        rarity: "rare",
        name: "Silencing",
        shortDesc: "A silencing weapon makes no noise when drawn or when used to attack. In addition, after hitting a creature, the wielder can surround that creature with an aura that muffles all sounds coming from it until the beginning of the wielder’s next turn. The target can still hear and speak (including uttering command words or casting spells with verbal components), but is much harder to hear. The DC of Perception checks to hear the sound of battle increases from –10 to 10, as long as the only combatants are the wielder of the silencing weapon and targets affected by the weapon’s muffling ability. If the wielder confirms a critical hit with a silencing weapon, the target is also encased in a mobile aura of magical silence (Will DC 10 + bab + enhancement modifier negates), which lasts a number of rounds equal to the critical multiplier of the weapon. The save DC increases by 2 for each critical multiplier of the weapon higher than ×2. This silence fills the target’s space but doesn’t extend beyond it.",
        },
        {
        class: "weapon",
        rarity: "rare",
        name: "Planar",
        shortDesc: "When used to attack outsiders, a planar weapon ignores 5 points of their damage reduction.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Menacing",
        shortDesc: "A menacing weapon helps allies deal with flanked foes. When the wielder is adjacent to a creature that is being flanked by an ally, the flanking bonus on attack rolls for all flanking allies increases by +2. This ability works even if the wielder is not one of the characters flanking the creature.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Lifesurge",
        shortDesc: "A lifesurge weapon boosts and sustains the wielder’s life energy while he is in the throes of combat. The wielder gains a bonus on saving throws against necromantic effects—including the ability damage, ability drain, and energy drain powers of the undead—equal to the weapon’s enhancement bonus(minimum 1). In addition, whenever the wielder receives temporary hit points from any source, he adds the weapon’s enhancement bonus to these temporary hit points(minimum 1); this does not stack for temporary hit points from multiple sources, and these points are lost if the lifesurge weapon is not being wielded. In combat, the weapon’s critical threat range is doubled against undead; this does not stack with the other affects that double crit range but instead adds a flat +1 that isn't doubled by your other abilities. Whenever a lifesurge weapon confirms a critical hit against an undead creature, it erupts with 1d8 points of positive energy (2d8 for weapons with a critical multiplier of x3, 3d8 if it is x4, etc.); the wielder may choose to deal this as damage to an undead target or to absorb half this amount as healing, with the remaining positive energy dissipating.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Liberating",
        shortDesc: "When a liberating weapon is used to attack a creature under direct mental control, such as from possession, charm effects, or compulsion effects like command and dominate person, the weapon deals nonlethal damage and grants the target a new saving throw against the effect, with a morale bonus on the save equal to the weapon’s enhancement bonus. If the target is affected by multiple such effects, the weapon’s wielder chooses which effect the target can attempt a second save against. If the target fails this save, they immune to this effect of the same liberating weapon for 24 hours.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Ki Intensifying",
        shortDesc: "The weapon channels and amplifies the wielder’s ki, allowing her to use her special ki attacks through the weapon as though they were unarmed attacks. These attacks include the quivering palm, and Stunning Fist feat, style strikes, and other feats that require you to use an unarmed attack. The save DC for ki abilities used through the weapon increases by half the enhancement bonus of the weapon (minimum 1). After a successful strike with a ki intensifying weapon, the wielder can spend 3 spell points as a swift action to perform a combat maneuver to bull rush, disarm, reposition, or trip as a free action without provoking attacks of opportunity. Any bonuses or penalties applicable to the weapon attack also apply to this combat maneuver check. The wielder cannot move from her space as a part of the chosen maneuver.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Impact",
        shortDesc: "An impact weapon delivers a potent kinetic jolt when it strikes, dealing damage as if the weapon were one size category larger. In addition, any bull rush combat maneuver the wielder attempts while wielding the weapon gains a bonus equal to the weapon’s enhancement bonus; this includes all bull rush attempts, not only those in which a weapon is used, such as Bull Rush Strike, Shield Slam, or Unseat.",
        },
        {
        class: "rangement",
        rarity: "rare",
        name: "Heartseeker",
        shortDesc: "A heartseeker weapon ignores the miss chance for concealment against most living targets, though the attack must still target the proper square. This special ability does not apply against aberrations, oozes, plants, outsiders with the elemental subtype, or any creature specifically noted to lack a heart.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Defiant",
        shortDesc: "A defiant weapon helps its wielder stay alive in desperate conditions. It stays in its wielder’s hand even if she is panicked, stunned, or unconscious. She adds the weapon’s enhancement bonus as a bonus on checks to stabilize when dying and on saving throws to end ongoing conditions such as disease, poison, and hold person. If the wielder possesses Heroic Defiance, Heroic Recovery, Improved Great Fortitude, Improved Iron Will, or Improved Lightning Reflexes, she gains a number of additional daily uses equal to the weapon’s enhancement bonus that can be used on any of these feats.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Confounding",
        shortDesc: "When the wielder confirms a critical hit with a confounding weapon, she can spend 2 spell points to attempt a combat maneuver to disarm, reposition, sunder, or trip the target as an immediate action, gaining an enhancement bonus on the combat maneuver check equal to the enhancement bonus of the confounding weapon. This combat maneuver does not provoke an attack of opportunity",
        },
        {
        class: "all",
        rarity: "rare",
        name: "Conductive",
        shortDesc: "A conductive weapon is able to channel the energy of a spell-like or supernatural ability that relies on a melee or ranged touch attack to hit its target (such as from a cleric’s domain granted power, sorcerer’s bloodline power, oracle’s mystery revelation, or wizard’s arcane school power). When the wielder makes a successful attack of the appropriate type, he may choose to expend two uses of his magical ability to channel it through the weapon to the struck opponent, which suffers the effects of both the weapon attack and the special ability. (If the wielder has unlimited uses of a special ability, she may channel through the weapon every round.) For example, a paladin who strikes an undead opponent with her conductive greatsword can expend two uses of her lay on hands ability (a supernatural melee touch attack) to deal both greatsword damage and damage from one use of lay on hands. A given character can use this weapon special ability only once per round (even if she has several conductive weapons), and the power works only with magical abilities of the same type as the weapon (melee or ranged).",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Bewildering",
        shortDesc: "for Level/2 spell points when the wielder of a bewildering weapon makes a successful attack with this weapon, in addition to dealing the weapon’s normal damage, the wielder can inflict the confused condition on that enemy for 1d4 rounds. The target can attempt a DC 10+bab Will saving throw each round to end this effect.",
        },
        {
            class: "melee",
            rarity: "common",
            name: "Parrying",
            shortDesc: "You gain a +1 insight bonus to AC and while wielding this weapon.",
        },
        {
            class: "all",
            rarity: "rare",
            name: "Shattermantle",
            shortDesc: "Creature's struck by this weapon have their spell resistance reduced by 1 for 1 round. This stacks, reducing the spell resistance for each successful attack, but not the duration.",
        },
        {
            class: "all",
            rarity: "epic",
            name: "Greater Parrying",
            shortDesc: "You gain a +2 insight bonus to AC and saves while wielding this weapon.",
        },
        {
            class: "all",
            rarity: "epic",
            name: "Flaming Burst",
            shortDesc: "1d10 fire damage. This weapon deals an additional 1d10 fire damage on critical hits if the critical multiplier is x2. For each multiplier above that, it deals an additional 1d10 fire damage. This also grants 10 fire spell power, and 15% fire spell critical damage.",
            damageMod:"1d10",
            spellPower:[{type:"fire", power:10}],
            spellCriticalDamage:[{type:"fire", power:15}]
        },
        {
            class: "all",
            rarity: "epic",
            name: "Frost Burst",
            shortDesc: "1d10 cold damage. This weapon deals an additional 1d10 cold damage on critical hits if the critical multiplier is x2. For each multiplier above that, it deals an additional 1d10 cold damage. This also grants 10 cold spell power, and 15% cold spell critical damage.",
            damageMod:"1d10",
            spellPower:[{type:"cold", power:10}],
            spellCriticalDamage:[{type:"cold", power:15}]
        },
        {
            class: "all",
            rarity: "epic",
            name: "Corrosive Burst",
            shortDesc: "1d10 acid damage. This weapon deals an additional 1d10 acid damage on critical hits if the critical multiplier is x2. For each multiplier above that, it deals an additional 1d10 acid damage. This also grants 10 acid spell power, and 15% acid spell critical damage.",
            damageMod:"1d10",
            spellPower:[{type:"acid", power:10}],
            spellCriticalDamage:[{type:"acid", power:15}]
        },
        {
            class: "all",
            rarity: "epic",
            name: "Shocking Burst",
            shortDesc: "1d10 electricity damage. This weapon deals an additional 1d10 electricity damage on critical hits if the critical multiplier is x2. For each multiplier above that, it deals an additional 1d10 electricity damage. This also grants 10 electricity spell power, and 15% electricity spell critical damage.",
            damageMod:"1d10",
            spellPower:[{type:"electricity", power:10}],
            spellCriticalDamage:[{type:"electricity", power:15}]
        },
        {
        class: "all",
        rarity: "rare",
        name: "Flaming",
        shortDesc: "1d6 fire damage. This also grants 10 fire spell power.",
        damageMod:"1d6",
        spellPower:[{type:"fire", power:10}]
        },
        {
            class: "all",
            rarity: "epic",
            name: "Greater Flaming",
            shortDesc: "2d6 fire damage. This also grants 15 fire spell power.",
            damageMod:"2d6",
            spellPower:[{type:"fire", power:15}]
        },        
        {
            class: "all",
            rarity: "Legendary",
            name: "Sun-Touched",
            shortDesc: "4d6 fire damage. This also grants 20 fire spell power.",
            damageMod:"4d6",
            spellPower:[{type:"fire", power:20}]
        },
        {
        class: "all",
        rarity: "rare",
        name: "Shocking",
        shortDesc: "1d6 electricity damage. This also grants 10 electricity spell power.",
        damageMod:"1d6",
        spellPower:[{type:"electricity", power:10}]
        },
        {
            class: "all",
            rarity: "epic",
            name: "Greater Shocking",
            shortDesc: "2d6 electricity damage. This also grants 15 electricity spell power.",
            damageMod:"2d6",
            spellPower:[{type:"electricity", power:15}]   
        },
        {
            class: "all",
            rarity: "Legendary",
            name: "Tempest's Wrath",
            shortDesc: "4d6 electricity damage. This also grants 20 electricity spell power.",
            damageMod:"4d6",
            spellPower:[{type:"electricity", power:20}]   
        },
        {
        class: "all",
        rarity: "rare",
        name: "Corrosive",
        shortDesc: "1d6 acid damage. This also grants 10 acid spell power.",
        damageMod:"1d6",
        spellPower:[{type:"acid", power:10}]
        },
        {
            class: "all",
            rarity: "epic",
            name: "Greater Corrosive",
            shortDesc: "2d6 acid damage. This also grants 15 acid spell power.",
            damageMod:"2d6",
            spellPower:[{type:"acid", power:15}]
        },
        {
            class: "all",
            rarity: "Legendary",
            name: "Dissolution",
            shortDesc: "4d6 acid damage. This also grants 20 acid spell power.",
            damageMod:"4d6",
            spellPower:[{type:"acid", power:20}]
        },
        {
        class: "all",
        rarity: "rare",
        name: "Frost",
        shortDesc: "1d6 cold damage. This also grants 10 cold spell power.",
        damageMod:"1d6",
        spellPower:[{type:"cold", power:10}]
        },
        {
            class: "all",
            rarity: "epic",
            name: "Greater Frost",
            shortDesc: "2d6 cold damage. This also grants 15 cold spell power.",
            damageMod:"2d6",
            spellPower:[{type:"cold", power:15}]
        },
        {
            class: "all",
            rarity: "Legendary",
            name: "True Frost",
            shortDesc: "4d6 cold damage. This also grants 20 cold spell power.",
            damageMod:"4d6",
            spellPower:[{type:"cold", power:20}]
        },
        {
            class: "weapon",
            rarity: "common",
            name: "Silvered",
            shortDesc: "The weapon also counts as being made of silver for the DR it bypasses and the damage it deals (for mithral current). This does not change its hardness or hit points. If it is used to attack a creature with DR bypassed specifically by silver, it deals an additional 1d6 damage. If it would have bypassed DR silver because of its enhancement bonus, the damage increases to 2d6 damage.",
        },
        {
            class: "weapon",
            rarity: "common",
            name: "Cold Iron",
            shortDesc: "The weapon bypasses DR as if it were cold iron. This does not change its hardness or hit points. If it is used to attack a creature with DR bypassed specifically by cold iron, it deals an additional 1d6 damage. If it would have bypassed DR cold iron because of its enhancement bonus, the damage increases to 2d6 damage.",
        },
        {
            class: "weapon",
            rarity: "epic",
            name: "Adamantine",
            shortDesc: "The weapon also counts as being adamantine for the DR it bypasses, and it ignores hardness of less than 20 when sundering weapons or attacking objects. This does not change its hardness or hit points. If it is used to attack a creature with DR bypassed by specifically admantine, it deals an additional 2d6 damage. If it would have bypassed DR specifically because of its enhancement bonus, the damage increases to 2d6 damage.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Fortuitous",
        shortDesc: "A fortuitous weapon grants the wielder more attacks of opportunity. Once per round, when the wielder of a fortuitous weapon hits with an attack of opportunity, he can make a second attack of opportunity (that doesn't expend an attack of opportunity) with this weapon against that foe at a –5 penalty.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Mighty Cleaving",
        shortDesc: "Once per round when you hit and deal damage to a creature with this weapon you can make an additional attack against another creature within your reach and adjacent to the original creature struck. This is an entirely new attack and no bonuses applied to the first attack apply to this one unless they apply to all attacks in a full round attack.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Keen",
        shortDesc: "This ability doubles the critical threat range of a weapon. Keen never doubles critical threat ranges gained from flat increases (Eg: +1 to critical threat range). If you already had an ability that doubled the weapons critical threat range, this instead provides a flat +1 bonus to the weapons critical threat range.",
        },
        {
        class: "ranged",
        rarity: "rare",
        name: "Shadow Shooting",
        shortDesc: "A shadowshooting weapon never needs to be reloaded; after a shot is fired, this smoke immediately coalesces into the ammunition required to fire the weapon again. This doesn’t prevent a shadowshooting weapon from firing ordinary projectiles appropriate to the weapon. Ammunition created by this ability is only quasi-real, and the first time each round an opponent is hit by a piece of ammunition that this ability has created, it can attempt a Will saving throw to disbelieve (DC = 15 + the weapon’s enhancement bonus). A failed Will saving throw means the weapon deals damage normally, while success means the weapon deals minimum damage against that opponent for 1 round.",
        },
        {
        class: "ranged",
        rarity: "common",
        name: "Reloading",
        shortDesc: "A reloading weapon can be reloaded once per round as a free action.",
        },
        {
        class: "melee",
        rarity: "rare",
        name: "Culling",
        shortDesc: "When a culling weapon is used to make an attack with a feat or ability that allows for a cleaving attack, such as Cleave or Cleaving finish, or a maneuver that cleaves, it deals an additional 2d6 points of damage on both the initial attack and any additional attacks granted.",
        },
        // {
        // class: "weapon",
        // rarity: "epic",
        // name: "Disciplined Blade",
        // shortDesc: "While wielding this weapon you can reduce the spell point cost of maneuvers by 2, but their minimum cost is still 1 spell point.",
        // },
        {
        class: "weapon",
        rarity: "unique",
        name: "Lifestealer",
        shortDesc: "Lifestealer gains +2 to attack and damage per negative level the target has, additionally, when you confirm a critical hit the target receives 1 temporary negative level. Negative levels given with this weapon give you 1d12+con temporary hit points per negative level the creature has after the negative level is given. These stack. You gain these temporary hit points even if the target is immune to negative levels",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Void Blade",
        shortDesc: "If you have lay on hands, channel energy, hemomancy, or touch of corruption, you can spend spell points equal to the cost of using that ability x 2 as a standard action, then for attacks equal to the amount of dice rolled for using that ability the Void Blade becomes charged, causing it to 1 give negative level with each hit.",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Bastards Sting",
        shortDesc: "This weapon deals 1d6 x enhancement bonus (minimum 1d6) points of negative energy damage to all living creatures that start their turn adjacent to the wielder. The User also gains fast healing 2 x enhancement bonus as long as at least one living creature takes damage from this negative energy",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Warbringer",
        shortDesc: "Warbringer enhancement bonus increases by +2 while raging. Whenever you confirm a critical hit you gain a +4 morale boost to strength and constitution for rounds equal to the weapons enchantment bonus (minimum 1), this stacks with rage, and if you have rage active when this activates, it instead of +4, it doubles whatever bonus you gain to strength and constitution from your rage.",
        },
        {
        class: "melee",
        rarity: "unique",
        name: "Perfect Balance",
        shortDesc: "This weapon adds both your strength and dexterity modifier to its damage. Both ability scores are added at the normal ratio, so if you're using a two handed weapon you gain 1.5x the modifiers, and if its an off-hand weapon it gains 0.5x. If the difference between your strength score and dexterity score is less than this weapons enhancement bonus, your critical damage multiplier increases by +1.",
        },
        {
        class: "all",
        rarity: "unique",
        name: "Learning",
        shortDesc: "Every time you successfully hit and damage an opponent with this weapon you gain a +1 insight to attack and damage against it on further attacks with this weapon (this stacks with itself), up to a maximum of the weapons enhancement modifier.",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "The Discipline Weapon",
        shortDesc: "Increase the DC's of all maneuvers and stances by 2, additionally once per turn as a free action you can double the bonus damage given by a maneuver or stance for one attack. The bonus damage only affects one creature at a time even if the attack hits multiple creatures at once.",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Living Blade",
        shortDesc: "Every time you successfully kill a creature with this weapon during combat it permanently grows in strength, gaining a +1 to damage, this bonus even lasts through floors, however if you end a floor without having got any kills with it, it loses its stacks and gains a permanent -4 to attack and damage. Additionally whenever you kill a creature you heal 1 point of health for each stack of this ability, and this sword repairs twice as much damage it has to itself.",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Sharpening",
        shortDesc: "Every time you attack and deal damage to a creature with this weapon its critical threat range against it increases by +1, this is a flat amount not modified by other abilities, however once you successfully confirm a critical hit against a creature this ability resets back to 0.",
        },
        {
        class: "melee",
        rarity: "unique",
        name: "Slugger",
        shortDesc: "Your critical hits no longer double modifiers to your damage, but only the weapons dice, increase your critical damage multiplier by +2.",
        },
        {
        class: "all",
        rarity: "legendary",
        name: "Greater Vampiric",
        shortDesc: "Regain 3 hit points every time you hit a creature and deal damage with this weapon.",
        },
        {
        class: "all",
        rarity: "legendary",
        name: "Greater Draining",
        shortDesc: "If you strike a creature with this weapon you restore 2 spell points. If you cast a spell that successfully deals damage to a creature while wielding this weapon you can also regain 2 spell points, this can only trigger once per spell.",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Bloodthirster",
        shortDesc: "This weapon deals 1d4 points of stacking bleed damage on each successful attack. when you confirm a critical hit deal an extra 1d3 damage per stack of bleed affecting the target from this weapon, this additional damage is not multiplied by the critical hit. If a creature attempts to heal a creature with positive energy that is currently affected by bleed from this weapon, the caster must make a caster level check dc=10+stacks of bleed + the weapons enhancement bonus or half of the healing the target would receive is instead given to you, and they receive none.",        
        },
        {
        class: "melee",
        rarity: "unique",
        name: "Titanic",
        shortDesc: "This weapon can now only use strength for attack and damage, and gains a permanent -4 to attack, but increase its damage dice by 2 sizes.",
        },
        {
        class: "melee",
        rarity: "unique",
        name: "Horde Slayer",
        shortDesc: "You can choose to increase your reach with this weapon by 5 feet for the rest of your turn as a swift action that costs 4 spell points, if you do your melee attacks with it become a cone attack, with the cone being equal to your reach. For each attack roll once applying the roll against the armor class of all targets within the cone.",
        },
        {
        class: "all",
        rarity: "unique",
        name: "Elemental Blade",
        shortDesc: "This blade deals an additional 3d6 elemental damage on succesful hits. You can change which element(fire, cold, corrosive, shock) this damage is as a swift action. Whichever active element this weapon has, it also grants 15 spell power for that element.",
        damageMod:"3d6"
        },
        {
        class: "all",
        rarity: "unique",
        name: "+5",
        shortDesc: "+5 to attack and damage. It also grants 10 universal spell power.",
        spellPower:[{type:"universal", power:10}],
        },        
        {
        class: "weapon",
        rarity: "unique",
        name: "Blood Sucking",
        shortDesc: "On a confirmed critical hit Blood Sucking weapon deals 1d3 points of con damage and the target must make a fort save DC=(20+ BAB + enhancement bonus) each turn or lose 1 more con until it saves. For each point of con damage from this weapon deals you gain 1d8 + your con modifier temporary hp that lasts 1 minute. This stacks.",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Valor Blade",
        shortDesc: "Valor blade gains a +1 critical damage multiplier and lets the wielder smite once per floor, (The smite only works if the creature has an opposite good/evil alignment as yours, if you are neutral you can smite both good and evil creatures, but you only gain half the effect. allowing you to add your highest mental stat to attack and as a deflection modifier to ac against attacks from the creature and a bonus to damage equal to your level. If the target is the exact opposite alignment from you (such as lawful good vs chaotic evil, or neutral good vs neutral evil) your first attack against the creature instead adds twice your level to damage). When attacking a target that you have activated smite on you gain a +1 bonus to critical threat range (this isn't doubled by other abilities). If its your direct opposing alignment this increase is instead 2. If you already have the ability to smite increase all bonuses of smite by 2, and reduce its cost by 3 spell points (to a minimum of 1)",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Terror Blade",
        shortDesc: "Each time you strike a target with the Terror Blade they become shaken for 1 round that stacks, on confirm crit target must make will save dc=10 + Intimidate + rounds left shacken or become terrified for 1 round.",
        },
        {
        class: "all",
        rarity: "unique",
        name: "Lucky",
        shortDesc: "Instead of threatening a critical fumble on a natural 1 it instead automatically hits, you must still confirm as normal or you can both critically fumble and hit the target with the same attack. Firearms still misfire, though their attack is not an automatic miss.",
        },
        {
            class: "ranged",
            rarity: "legendary",
            name: "Reliable",
            shortDesc: "When this enchantment is placed on a firearm, whenever it would misfire, it has a 50% chance to not become broken or destroyed, instead just missing that attack. This also causes the portable cannons special effect to only occur 50% of the time. If you have this enchantment multiple times, it increases the chance to not misfire by 50% of the remaining chance to not misfire (eg 25%, then 12%, then 6% etc.)",
        },
        {
            class: "weapon",
            rarity: "rare",
            name: "Cunning",
            shortDesc: "When you score a successful critical hit with this weapon, it deals bonus damage equal to the total bonus you have to the knowledge skill required to identify it. This damage is added after the damage is multiplied.",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Deadly Precision",
        shortDesc: "When confirming a critical hit, if you roll within your potential critical hit range, you can spend spell points equal to the weapons critical threat range x3 (15-20 crit range equals 15 spell points), you can roll to confirm again with a -6 to attack, if you succeed increase your critical damage multiplier by +1. This can be activated multiple times on a single crit but the -6 is cumulative.",
        },
        {
        class: "weapon",
        rarity: "unique",
        name: "Shadow Blade",
        shortDesc: "Attacks made with Shadow Blade gain +3d6 of sneak attack damage. Confirmed critical hits with Shadow Blade multiply sneak attack damage.",
        },
        {
        class: "rangement",
        rarity: "unique",
        name: "Double Barrel",//change universal
        shortDesc: "All attacks made from this weapon fire an additional projectile as if using the manyshot feat. The second projectile adds base damage, but precision based abilities and critical hit damage applies only once.",
        additionalInfoTags:["multishot"],
        },
        {
        class: "weapon",
        rarity: "legendary",
        name: "Scholar's Blade",
        shortDesc: "This weapon can use your highest mental modifier to determine its attack and damage in place of their normal ability score modifier.",
        },
        {
        class: "all",//change universal
        rarity: "legendary",
        name: "Time Altering",
        shortDesc: "While wielding this weapon once per round you can spend level/2 spell points to gain an additional swift action. You can only use this ability once per round.",
        },
        {
            class: "armament",
            rarity: "unique",
            name: "Archmages Focus",
            shortDesc: "Reduce the level modification of all metamagic feats by 1.",
        },
        {
            class: "all",
            rarity: "legendary",
            name: "Magical Aim",
            shortDesc: "This weapon can use your highest mental modifier to determine its attack modifier.",
        },
        {
            class: "armament",
            rarity: "unique",
            name: "Gemeni Sigil",
            shortDesc: "Double the effects of the base power of this weapon.",
        },
        {
            class: "armament",
            rarity: "legendary",
            name: "Tuned Core",
            shortDesc: "Attacking with this weapon costs 1 less spell point. This cannot reduce the spell point cost below 1.",
        },
        {
            class: "armament",
            rarity: "unique",
            name: "Warmage's Opportunity",
            shortDesc: "Whenever you score a critical hit with a spell, you can as a swift action make an attack with this weapon against a creature that you scored the critical hit against.",
        },

        {
            class: "armament",
            rarity: "common",
            name: "Minor Spell Focus",
            shortDesc: `Spells of the specific type gain a +1 bonus to their DC.`,
            multiSelect:["Damage","Control","Healing","Buff","Utility"],
        },
        {
            class: "armament",
            rarity: "rare",
            name: "Lesser Spell Focus",
            shortDesc: `Spells of the specific type gain a +2 bonus to their DC.`,
            multiSelect:["Damage","Control","Healing","Buff","Utility"],
        },
        {
            class: "armament",
            rarity: "epic",
            name: "Improved Spell Focus",
            shortDesc: `Spells of the specific type gain a +3 bonus to their DC.`,
            multiSelect:["Damage","Control","Healing","Buff","Utility"],
        },
        {
            class: "armament",
            rarity: "legendary",
            name: "Greater Spell Focus",
            shortDesc: `Spells of the specific type gain a +4 bonus to their DC.`,
            multiSelect:["Damage","Control","Healing","Buff","Utility"],
        },
        {
            class: "armament",
            rarity: "unique",
            name: "Mythic Spell Focus",
            shortDesc: `Spells of the specific type gain a +5 bonus to their DC.`,
            multiSelect:["Damage","Control","Healing","Buff","Utility"],
        },
        {
            class: "armament",
            rarity: "common",
            name: "Minor Spell Lore",
            shortDesc: `When you cast a spell that deals damage or heals while wielding this weapon, increase its critical chance by 1%.`,
            multiSelect:["fire","cold","acid","electricity","positive", "negative"],
            additionalInfoTags:["Percentage Spell Critical"],
            spellCriticalChance:[{type:"undecided", power:1}],
            multiSelectTypes:[{type:"spellCriticalChance",index:0}]
        },
        {
            class: "armament",
            rarity: "rare",
            name: "Lesser Spell Lore",
            shortDesc: `When you cast a spell that deals damage or heals while wielding this weapon, increase its critical chance by 1%. If the spell is of the specific type, it increases to 2%.`,
            multiSelect:["fire","cold","acid","electricity","positive", "negative"],
            additionalInfoTags:["Percentage Spell Critical"],
            spellCriticalChance:[{type:"undecided", power:1}, {type:"universal", power:1}],
            multiSelectTypes:[{type:"spellCriticalChance",index:0}]
        },
        {
            class: "armament",
            rarity: "epic",
            name: "Improved Spell Lore",
            shortDesc: `When you cast a spell that deals damage or heals while wielding this weapon, increase its critical chance by 2%. If the spell is of the specific type, it increases to 4%.`,
            multiSelect:["fire","cold","acid","electricity","positive", "negative"],
            additionalInfoTags:["Percentage Spell Critical"],
            spellCriticalChance:[{type:"undecided", power:2}, {type:"universal", power:2}],
            multiSelectTypes:[{type:"spellCriticalChance",index:0}]
        },
        {
            class: "armament",
            rarity: "legendary",
            name: "Greater Spell Lore",
            shortDesc: `When you cast a spell that deals damage while wielding this weapon, increase its critical chance by 3%. If the spell is of the specific type, it increases to 6%.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            additionalInfoTags:["Percentage Spell Critical"],
            spellCriticalChance:[{type:"undecided", power:3}, {type:"universal", power:3}],
            multiSelectTypes:[{type:"spellCriticalChance",index:0}]
        },
        {
            class: "armament",
            rarity: "unique",
            name: "Grand Spell Lore",
            shortDesc: `When you cast a spell that deals damage while wielding this weapon, increase its critical chance by 5%. If the spell is of the specific type, it increases to 10%.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            additionalInfoTags:["Percentage Spell Critical"],   
            spellCriticalChance:[{type:"undecided", power:5}, {type:"universal", power:5}],
            multiSelectTypes:[{type:"spellCriticalChance",index:0}]
        },

        

        {
            class: "armament",
            rarity: "common",
            name: "Minor Spell Focusing",
            shortDesc: `Gain 13 spell power of the specific type. Gain 2 universal spell power.`,
            multiSelect:["fire","cold","acid","electricity","positive","negative"],
            spellPower:[{type:"universal", power:2}, {type:"undecided", power:13}],
            multiSelectTypes:[{type:"spellPower",index:1}]
        },
        {
            class: "armament",
            rarity: "rare",
            name: "Lesser Spell Focusing",
            shortDesc: `Gain 16 spell power of the specific type. Gain 4 universal spell power.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            spellPower:[{type:"universal", power:4}, {type:"undecided", power:16}],
            multiSelectTypes:[{type:"spellPower",index:1}]
        },
        {
            class: "armament",
            rarity: "epic",
            name: "Improved Spell Focusing",
            shortDesc: `Gain 19 spell power of the specific type. Gain 6 universal spell power.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            spellPower:[{type:"universal", power:6}, {type:"undecided", power:19}],
            multiSelectTypes:[{type:"spellPower",index:1}]
        },
        {
            class: "armament",
            rarity: "legendary",
            name: "Greater Spell Focusing",
            shortDesc: `Gain 22 spell power of the specific type. Gain 8 universal spell power.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            spellPower:[{type:"universal", power:8}, {type:"undecided", power:22}],
            multiSelectTypes:[{type:"spellPower",index:1}]
        },
        {
            class: "armament",
            rarity: "unique",
            name: "Grand Spell Focusing",
            shortDesc: `Gain 25 spell power of the specific type. Gain 10 universal spell power.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            spellPower:[{type:"universal", power:10}, {type:"undecided", power:25}],
            multiSelectTypes:[{type:"spellPower",index:1}]
        },

        

        {
            class: "armament",
            rarity: "common",
            name: "Minor Elemental Penetration",
            shortDesc: `Spells that deal damage of the specified type bypass 3 resistance to that element. Gain 3 spell power of that element.`,
            multiSelect:["fire","cold","acid","electricity"],
            spellPower:[{type:"undecided", power:3}],
            multiSelectTypes:[{type:"spellPower",index:0}]
        },
        {
            class: "armament",
            rarity: "rare",
            name: "Lesser Elemental Penetration",
            shortDesc: `Spells that deal damage of the specified type bypass 5 resistance to that element. Gain 5 spell power of that element.`,
            multiSelect:["fire","cold","acid","electricity"],
            spellPower:[{type:"undecided", power:5}],
            multiSelectTypes:[{type:"spellPower",index:0}]
        },
        {
            class: "armament",
            rarity: "epic",
            name: "Improved Elemental Penetration",
            shortDesc: `Spells that deal damage of the specified type bypass 10 resistance to that element. Gain 7 spell power of that element.`,
            multiSelect:["fire","cold","acid","electricity"],
            spellPower:[{type:"undecided", power:7}],
            multiSelectTypes:[{type:"spellPower",index:0}]
        },
        {
            class: "armament",
            rarity: "legendary",
            name: "Greater Elemental Penetration",
            shortDesc: `Spells that deal damage of the specified type bypass 15 resistance to that element. Gain 10 spell power of that element.`,
            multiSelect:["fire","cold","acid","electricity"],
            spellPower:[{type:"undecided", power:10}],
            multiSelectTypes:[{type:"spellPower",index:0}]
        },
        {
            class: "armament",
            rarity: "unique",
            name: "Grand Elemental Penetration",
            shortDesc: `Spells that deal damage of the specified type bypass 20 resistance to that element. Gain 15 spell power of that element.`,
            multiSelect:["fire","cold","acid","electricity"],
            spellPower:[{type:"undecided", power:15}],
            multiSelectTypes:[{type:"spellPower",index:0}]
        },


        {
            class: "armament",
            rarity: "common",
            name: "Minor Spell Devastation",
            shortDesc: `Critical spells gain 5% critical power. Spells of the specified type gain an additional 10% critical power.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            spellCriticalDamage:[{type:"universal", power:5}, {type:"undecided", power:10}],
            multiSelectTypes:[{type:"spellCriticalDamage",index:0}]
        },
        {
            class: "armament",
            rarity: "rare",
            name: "Lesser Spell Devastation",
            shortDesc: `Critical spells gain 8% critical power. Spells of the specified type gain an additional 12% critical power.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            spellCriticalDamage:[{type:"universal", power:8}, {type:"undecided", power:12}],
            multiSelectTypes:[{type:"spellCriticalDamage",index:0}]
        },
        {
            class: "armament",
            rarity: "epic",
            name: "Improved Spell Devastation",
            shortDesc: `Critical spells gain 10% critical power. Spells of the specified type gain an additional 15% critical power.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            spellCriticalDamage:[{type:"universal", power:10}, {type:"undecided", power:15}],
            multiSelectTypes:[{type:"spellCriticalDamage",index:0}]
        },
        {
            class: "armament",
            rarity: "legendary",
            name: "Greater Spell Devastation",
            shortDesc: `Critical spells gain 12% critical power. Spells of the specified type gain an additional 20% critical power.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            spellCriticalDamage:[{type:"universal", power:12}, {type:"undecided", power:20}],
            multiSelectTypes:[{type:"spellCriticalDamage",index:0}]
        },
        {
            class: "armament",
            rarity: "unique",
            name: "Grand Spell Devastation",
            shortDesc: `Critical spells gain additional 15% critical power. Spells of the specified type gain an additional 25% critical power.`,
            multiSelect:["fire","cold","acid","electricity", "positive", "negative"],
            spellCriticalDamage:[{type:"universal", power:15}, {type:"undecided", power:25}],
            multiSelectTypes:[{type:"spellCriticalDamage",index:0}]
        },
]

/*
Gain a random magical feat when wielding it

reduce SP costs for spells
spell damage (2%/4%/6%/10%/15%)
specific element damage (4%/8%/12%/20%/30%)

increase damage of armament (+2/+4/+6/+8/+10)
Bypass elemental resistances (+2/+4/+8/+10/+15)


caster level (E:+1/+2/+3)
specific type caster level (+1/+2/+3/+4/+5)
spell penetration (+1/+2/+3/+4/+7)
spell critical percent (1%/2%/3%/4%/5%)
spell critical damage (5%/10%/15%/20%/25%)
specific spell type critical change (2%/4%/6%/8%/10%)
specific spell elemental critical damage (10%/20%/30%/40%/50%)
spell DC (E:+1/+2/+3)
specific spell type DC (+1/+2/+3/+4/+5)
can use highest mental to attack

temp hp from SP
heal from SP
temp hp from damage
heal from damage
heal from control
heal self when you heal other

temp hp when cast spells on allies
heal allies when cast spells on allies
deflection when cast spells on allies

certain amount of spells that are discounted or hasted




convert enchantments to universal spell power in stores?

*/